import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import de from '../locales/de.json'
import fr from '../locales/fr.json'

const messages = {
  en,
  de,
  fr
}

// Map language codes from dropdown to i18n locale codes
const languageMap = {
  'EN': 'en',
  'GE': 'de', 
  'FR': 'fr'
}

const i18n = createI18n({
  legacy: false,
  locale: 'en', // default locale
  fallbackLocale: 'en',
  messages
})

export { languageMap }
export default i18n
